module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/accessories-3bb956827050ddf003032f9abab4a7ad.png";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/accessories.png
// module id = UwFR
// module chunks = 9 12